import type { UploadedFileStepType } from '../../types'
import type { RootState } from '../store'
import { multipartUploadedFileAdapter } from './multipartUploadedFileSlice'

export const { selectAll: selectMultipartUploadAll, selectById } =
  multipartUploadedFileAdapter.getSelectors<RootState>(state => state.uploadMultipartFiles)

export const selectMultipartStep = (state: RootState, id: string) => {
  const entity = selectById(state, id)
  return {
    step: entity?.step,
    statuses: entity?.statuses,
  }
}

const selectMultipartById = (state: RootState, id: string | undefined) =>
  id ? selectById(state, id) : undefined

export const selectMultipartProgress = (state: RootState, id: string | undefined) =>
  selectMultipartById(state, id)?.progress

export const selectMultipartStatus = (state: RootState, id: string, step: UploadedFileStepType) =>
  selectById(state, id)?.statuses?.[step]

export const selectActiveMultipartFile = (state: RootState) => state.uploadMultipartFiles.activeFile

export const selectMultipartConvertProgress = (state: RootState, id: string | undefined) =>
  selectMultipartById(state, id)?.convertProgress

export const selectMultipartFileByTaskId = (state: RootState, taskId: string) =>
  selectMultipartUploadAll(state).find(file => file.convertTaskId === taskId)

export const selectMultipartFileByUploadId = (state: RootState, uploadId?: string) => {
  if (!uploadId) return

  return selectMultipartUploadAll(state).find(file => file.uploadId === uploadId)
}

export const selectMultipartFileByCreatedEntityId = (state: RootState, createdEntityId: string) =>
  selectMultipartUploadAll(state).find(file => file.createdEntity?.id === createdEntityId)

export const selectMultipartContext = (state: RootState) => state.uploadMultipartFiles.context
